// extracted by mini-css-extract-plugin
export default {"wrapper":"OrphanEmail_wrapper__3Kqoq","contianer":"OrphanEmail_contianer__8IL8m","body_container":"OrphanEmail_body_container__lnLJm"};